import 'babel-polyfill';

import './scss/common.scss';
import 'animate.css';


// WEBPACK FOOTER //
// ./src/main.js